/**
 * 대금상환 팝업 날짜 입력 — flatpickr 바인딩 (TASK-161 결정 28 · 날짜 포맷 Y-m-d 통일)
 * ------------------------------------
 *  - 프로젝트 표준 = jquery-app.js 의 input.app-date-text 초기화 (dateFormat Y-m-d · allowInput · 한국어 · 8자리 자동 변환).
 *    모달 DOM 은 jQuery ready 초기화 대상이 아니므로 (Vue 렌더) 팝업 컴포넌트가 mounted() 에서 같은 옵션으로 직접 바인딩한다.
 *  - 값 동기: flatpickr 의 onChange 는 input 이벤트도 발생시키지만 (v-model 반영), 직접 타이핑 후 바깥 클릭으로 닫힐 때의
 *    자동 변환 (20261008 → 2026-10-08) 은 이벤트 없이 값만 바꾸므로 onChange · onClose 에서 input 의 현재 값을 콜백으로 넘긴다.
 *  - 캘린더 = flatpickr 기본 (document.body 에 붙고 z-index 99999) → UIkit 모달 (z-index 1010) 위에 표시된다.
 *  - 사용: paid-popup · correct-popup · batch/jobs/cod-payment-settle
 */
const flatpickr = require('flatpickr').default;
const Korean = require('flatpickr/dist/l10n/ko.js').default.ko;

/**
 * 입력 문자열 → Date (브라우저 로컬 자정)
 *  - 8자리 숫자 (YYYYMMDD) · Y-m-d 는 로컬 날짜로 해석 (new Date('Y-m-d') 의 UTC 해석 회피)
 *  - 그 외는 Date 기본 파싱
 */
function parseDate(dateStr) {
    let s = String(dateStr).replace(/\s/g, '');
    let m = /^(\d{4})-?(\d{2})-?(\d{2})$/.exec(s);
    if (m) {
        return new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
    }
    return new Date(s);
}

/**
 * 날짜 input 에 flatpickr 바인딩
 *
 * @param {HTMLInputElement} el
 * @param {function(string)} onValue 값 변경 콜백 (input 의 현재 값 = Y-m-d 또는 '')
 * @return {Object} flatpickr instance
 */
export function bindDateInput(el, onValue) {
    let sync = function (selectedDates, dateStr, instance) {
        onValue(instance.input.value);
    };
    return flatpickr(el, {
        dateFormat: 'Y-m-d',
        allowInput: true,
        locale: Korean,
        parseDate: parseDate,
        onChange: sync,
        onClose: sync,
    });
}

/**
 * 값 세팅 (팝업 open 시 기본값 · 프리필) — 이벤트 미발생 (호출측이 v-model 값을 이미 세팅)
 *
 * @param {Object|null} fp flatpickr instance
 * @param {string} value Y-m-d 또는 ''
 */
export function setDateInput(fp, value) {
    if (! fp) {
        return;
    }
    fp.setDate(value || '', false);
}

/**
 * 해제 (컴포넌트 beforeDestroy)
 *
 * @param {Object|null} fp flatpickr instance
 */
export function destroyDateInput(fp) {
    if (fp) {
        fp.destroy();
    }
}
